global.$ = global.jQuery;

import 'gsap/src/uncompressed/TweenMax';
import './helpers/autogrow';
import 'lazysizes';
import PriceSeter from './modules/priceSeter';
import HowSlider from './modules/how-slider';
import ClientSlider from './modules/client-slider'
import ProductSlider from './modules/product-slider'
import HasClass from './helpers/hasClass';
import IndustryBlocks from './modules/industry-blocks'

var body = new HasClass('body');

var main = {
    initPages() {
        /**
         * CONTACT
         */
        body.hasClasses(['page-id-26', 'page-id-157', 'page-id-873'], () => {
            $('.js-autogrow').autoGrowInput({minWidth: 150, maxWidth: 550, comfortZone: 40});
        });

        /**
         * SINGLE PRODUCT
         */
        body.has('single-product', () => {
            new ProductSlider('.js-slider-products', {
                dots: true,
                prevNextButtons: false,
                setGallerySize: false
            });

            new PriceSeter(global.PRODUCT_PRICES);
        });

        /**
         * HOMEPAGE
         */
        body.hasClasses(['home'], () => {
            new ClientSlider('.js-client-slider', {
                dots: false,
                speed: 500,
                cellAlign: 'left',
                contain: true,
                imagesLoaded: true,
                autoPlay: true,
                prevNextButtons: false,
                adaptiveHeight: false,
                wrapAround: false,
                groupCells: true
            });

            console.log('test');

            new IndustryBlocks();
        });

        /**
         * ABOUT
         */
        body.hasClasses(['page-id-159', 'page-id-24', 'page-id-867'], () => {
            new HowSlider('.js-how-slider', '.js-how-slider-nav', {
                dots: false,
                speed: 500,
                cellAlign: 'left',
                contain: false,
                prevNextButtons: false,
                adaptiveHeight: false,
                wrapAround: false
            });
        });

        /**
         * Shop Archive
         */
        body.has('archive', () => {
            body.has('woocommerce', () => {
                //TODO: add specific js code for shop archve pages
            })
        });
    },
    init() {
        var $drop = $('.js-nav-drop');
        var $nav = $('.js-navigation');

        $(document).on('click', '.js-toggle-form', () => {
            $('html').toggleClass('form-open');
            return false;
        });

        $(document).on('click', '.js-toggle-filter', () => {
            $('html').toggleClass('filter-open');
            return false;
        });

        $('.js-toggle-button').on('click', () => {
            $('html').toggleClass('menu-open');
            if ($nav.hasClass('drop-open')) {
                $nav.removeClass('drop-open');
                $('.js-nav-drop-menu').removeClass('open');
            }
        });

        $drop.on('click', (e) => {
            e.preventDefault();
            var drop = $(e.currentTarget).data('drop');

            if ($nav.hasClass('drop-open')) {
                $nav.removeClass('drop-open');
                $nav.find('.js-nav-drop-menu').removeClass('open');
            } else {
                $nav.addClass('drop-open');
                $('#js-drop-' + drop).toggleClass('open');
            }
        });

        $('.ninja-forms-form').on('submitResponse', function (e, response) {
            var errors = response.errors;
            if (errors == false) {
                $('.js-form').find('.col').append('<div class="btn-close js-toggle-form">Sluiten</div>');
            }
        });

        this.initPages();
    }
};

$(document).ready(() => {
    main.init();
    $(document.body).addClass('ready');
});